// AynWorld : sélecteur de variantes. Quand la combinaison choisie n'existe pas (ex. Clear Purple en Lite), on coche
// la première valeur disponible de l'option concernée. Un vrai clic sur l'input : Dawn recharge prix, stock,
// galerie et bouton par son propre circuit. Dawn remplace l'élément <variant-selects> entier à chaque changement :
// on observe donc son conteneur <product-info>, qui reste en place.
(() => {
  const fix = (selects) => {
    const fieldsets = selects.querySelectorAll('fieldset');
    for (let i = 1; i < fieldsets.length; i++) {
      const checked = fieldsets[i].querySelector('input:checked');
      if (!checked || !checked.classList.contains('disabled')) continue;
      const next = fieldsets[i].querySelector('input:not(.disabled)');
      if (next) next.click();
      return;
    }
  };
  // Galerie groupée par couleur : les vignettes suivent la liste principale (resynchronisée par Dawn).
  const syncThumbs = (info) => {
    const gallery = info.querySelector('media-gallery');
    const thumbs = gallery && gallery.querySelectorAll('.thumbnail-list [data-target]');
    if (!thumbs || !thumbs.length) return;
    const shown = new Set(
      Array.from(gallery.querySelectorAll('.product__media-list [data-media-id]')).map((li) => li.dataset.mediaId)
    );
    // Ne recalculer (et ne revenir au début) que si les vignettes affichées ont changé : la fiche se met à jour
    // toute seule (compte à rebours chaque seconde) et ramenait la rangée au début pendant un glissement.
    let changed = false;
    thumbs.forEach((thumb) => {
      const hide = !shown.has(thumb.dataset.target);
      if (thumb.hidden !== hide) {
        thumb.hidden = hide;
        changed = true;
      }
    });
    if (changed || !gallery.hasAttribute('data-aw-fit')) fitThumbs(gallery, changed);
  };
  // Rangée de vignettes qui tient à l'écran : centrée, flèches masquées (rien à faire défiler).
  const fitThumbs = (gallery, reset) => {
    const list = gallery.querySelector('.thumbnail-list');
    if (!list) return;
    gallery.setAttribute('data-aw-fit', '');
    list.classList.remove('aw-thumbs-fit');
    if (reset) list.scrollLeft = 0;
    const fits = list.scrollWidth <= list.clientWidth + 1;
    list.classList.toggle('aw-thumbs-fit', fits);
    gallery.querySelectorAll('.thumbnail-slider .slider-button').forEach((b) => b.classList.toggle('aw-hidden', fits));
  };
  let lastWidth = window.innerWidth;
  window.addEventListener('resize', () => {
    if (window.innerWidth === lastWidth) return;
    lastWidth = window.innerWidth;
    document.querySelectorAll('media-gallery').forEach((g) => fitThumbs(g, false));
  });
  const watch = (info) => {
    if (info.dataset.awWatch) return;
    info.dataset.awWatch = '';
    syncThumbs(info);
    new MutationObserver(() => {
      const selects = info.querySelector('variant-selects');
      if (selects) fix(selects);
      syncThumbs(info);
    }).observe(info, { childList: true, subtree: true });
  };
  const run = () => document.querySelectorAll('product-info').forEach(watch);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run);
  else run();
  document.addEventListener('shopify:section:load', run);
})();
